import React from 'react';
import Step1 from './content/step1';
import Step2 from './content/step2';
import Step3 from './content/step3';
import Step4 from './content/step4';
import PropTypes from 'prop-types';


const propTypes = {
    updateSearchDomain: PropTypes.func,
    updateIsDispOgImage: PropTypes.func,
    updateDispSearchNum: PropTypes.func,
    updateSearchFormDesign: PropTypes.func,
    closeModal: PropTypes.func
};

class Main extends React.Component {

    render() {

        let content = []
        let sub_title = this.props.contenttitle[this.props.step]

        //step1のメインコンテンツを読み込む
        if(this.props.step == 1){
            content.push(
                <Step1 
                    searchdomain={this.props.searchdomain}
                    isDispModal={this.props.isDispModal}
                    modalErrorMessage={this.props.modalErrorMessage}
                    updateSearchDomain={(domain) => { this.props.updateSearchDomain(domain); }}
                    closeModal={() => { this.props.closeModal(); }}                   
                />
            );
        //step2のメインコンテンツを読み込む
        }else if(this.props.step == 2){
            content.push(
                <Step2
                    isDispOgImage={this.props.isDispOgImage}
                    dispSearchNum={this.props.dispSearchNum}
                    updateIsDispOgImage={(check) => { this.props.updateIsDispOgImage(check); }}
                    updateDispSearchNum={(num) => { this.props.updateDispSearchNum(num); }}
                />
            );
        //step3のメインコンテンツを読み込む
        }else if(this.props.step == 3){
            content.push(
                <Step3
                    searchFormDesign={this.props.searchFormDesign}
                    isDispModal={this.props.isDispModal}
                    modalErrorMessage={this.props.modalErrorMessage}
                    updateSearchFormDesign={(type) => { this.props.updateSearchFormDesign(type); }}
                    closeModal={() => { this.props.closeModal(); }}
                />
            );
        //step4のメインコンテンツを読み込む
        }else if(this.props.step == 4){
            content.push(
                <Step4
                    searchdomain={this.props.searchdomain}
                    isDispOgImage={this.props.isDispOgImage}
                    dispSearchNum={this.props.dispSearchNum}
                    searchFormDesign={this.props.searchFormDesign}
                />
            );
        }

        return (
            <main id="contents" className="main-setting">
                <section className="section">
                    <h2 id="sub_title">{sub_title}</h2>
                    {content}
                </section>
            </main>
        );
    }
}

export default Main;

